import { useEffect, useState } from "react";

import { api, User } from "../../services/api";

/**
 * Cobranças is only for people in Brazil: an account in reais (receiving also needs a CPF and a Brazilian bank). The
 * same rule as the API's (User::currencyOf): the currency chosen in the Account, else Real for an account in Portuguese.
 */
export const isPaymentsEligible = (user: Pick<User, "currency" | "lang">) =>
  user.currency ? user.currency === "BRL" : (user.lang || "pt") === "pt";

/**
 * Whether the person can use Cobranças: "loading" while the account loads, "error" when it can't be read (the API
 * has the last word then), else true or false.
 */
export type PaymentsEligibility = boolean | "loading" | "error";

export const usePaymentsEligible = (): PaymentsEligibility => {
  const [eligible, setEligible] = useState<PaymentsEligibility>("loading");

  useEffect(() => {
    let current = true;
    api
      .getUser()
      .then(user => current && setEligible(isPaymentsEligible(user)))
      .catch(() => current && setEligible("error"));
    return () => {
      current = false;
    };
  }, []);

  return eligible;
};
